<template>
    <div>{{title}}</div>
</template>

<script>
export default {
    name: "Task",
    props: ['title']
}
</script>